var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74434 0.994901C5.51349 0.994939 5.28783 1.06342 5.0959 1.19169C4.90397 1.31996 4.75438 1.50226 4.66604 1.71554C4.57771 1.92882 4.55459 2.1635 4.59962 2.38992C4.64464 2.61633 4.75579 2.82431 4.919 2.98757L9.929 7.99957L4.919 13.0069C4.81058 13.1153 4.72456 13.244 4.66586 13.3856C4.60716 13.5272 4.57694 13.679 4.5769 13.8323C4.57684 14.142 4.69978 14.4389 4.91867 14.6579C5.13756 14.8769 5.43448 14.9999 5.7441 15C6.05372 15.0001 6.35069 14.8771 6.56967 14.6582L13.2297 7.99757L6.56967 1.33757C6.46138 1.22905 6.33273 1.14297 6.1911 1.08428C6.04947 1.0256 5.89765 0.995446 5.74434 0.995567L5.74434 0.994901Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.a45fd777c560ed18c1760b304d7dc797.svg";
export { ForwardRef as ReactComponent };